import React from 'react';
import { useLocation } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import { routePermissionMap } from '../../config/routePermissions';

const RouteGuard = ({ children, requiredPermission, requireAuth = true }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  if (requiredPermission) {
    return (
      <PermissionRoute permission={requiredPermission} requireAuth={requireAuth}>
        {children}
      </PermissionRoute>
    );
  }

  let permission = routePermissionMap[currentPath];

  if (!permission) {
    const pathParts = currentPath.split('/').filter(Boolean);
    for (let i = pathParts.length; i > 0; i -= 1) {
      const testPath = `/${pathParts.slice(0, i).join('/')}`;
      if (routePermissionMap[testPath]) {
        permission = routePermissionMap[testPath];
        break;
      }
    }
  }

  if (permission) {
    return (
      <PermissionRoute permission={permission} requireAuth={requireAuth}>
        {children}
      </PermissionRoute>
    );
  }

  return (
    <PermissionRoute requireAuth={requireAuth}>
      {children}
    </PermissionRoute>
  );
};

export default RouteGuard;
